import { render } from "./modal-permission-browser.vue?vue&type=template&id=1d18271d&ts=true"
import script from "./modal-permission-browser.vue?vue&type=script&lang=ts"
export * from "./modal-permission-browser.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__